import React from 'react';

const IntHeader = ({
  data,
  hideShowDataSource,
  //getDemoCsv
}) => {
  return (
    <div className="dataset-select-header" >
      <div className="title-dataset-label cursor" onClick={() => hideShowDataSource('back')}>
        {/* <img className="mr-2" src={data.img} alt="icon" /> */}
        <svg className="link-svg" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
          <path id="Path_59544" data-name="Path 59544" d="M10.9,7,12,5.917,6,0,0,5.917,1.1,7,6,2.165l.065.064Z" transform="translate(0 12) rotate(-90)" fill="#645cfc" opacity="0.987" />
        </svg>
        <h6>{data.dn}</h6>
      </div>
      <div className='integration-slipanel-close' onClick={() => hideShowDataSource('close')}>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
          <path id="Path_59483" data-name="Path 59483" d="M-440.148-160.721l3.3-3.3a1,1,0,0,0,0-1.407,1.019,1.019,0,0,0-1.408,0l-3.3,3.3-3.3-3.3a1.017,1.017,0,0,0-1.405,0,.986.986,0,0,0-.292.7.988.988,0,0,0,.292.7l3.3,3.3-3.3,3.3a.987.987,0,0,0-.292.7.988.988,0,0,0,.292.7,1,1,0,0,0,1.406,0l3.3-3.3,3.3,3.3a1,1,0,0,0,.7.291.992.992,0,0,0,.7-.291,1,1,0,0,0,0-1.407Z" transform="translate(446.554 165.712)" fill="#645cfc" />
        </svg>
      </div>
      {/* <svg onClick={() => getDemoCsv()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
        <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
      </svg> */}
      {/* <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7.197">
        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M6,2.17,10.54,6.933a.826.826,0,0,0,1.211,0,.939.939,0,0,0,0-1.274L6.61.262A.827.827,0,0,0,5.427.236L.25,5.655a.936.936,0,0,0,0,1.274.826.826,0,0,0,1.211,0Z" transform="translate(12 7.197) rotate(180)"></path>
      </svg> */}
    </div>
  );
};

export default IntHeader;


// WEBPACK FOOTER //
// ./src/components/Integration/IntHeader.js